/**
 * Shared theme tokens for `@uiw/react-json-view`.
 *
 * Exposes a brighter dark variant tuned for our dark-mode surfaces and
 * re-exports the package's lightTheme for symmetry. Used in both the admin
 * log viewer and inline event-content data dumps so they stay visually
 * consistent.
 */
import { lightTheme } from "@uiw/react-json-view/light";

/** Bright zinc/violet/green dark theme matching the admin LogRow viewer. */
export const brighterDarkTheme = {
  "--w-rjv-font-family":
    "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
  "--w-rjv-color": "#e4e4e7", // zinc-200
  "--w-rjv-key-string": "#c4b5fd", // violet-300
  "--w-rjv-background-color": "transparent",
  "--w-rjv-line-color": "#52525b", // zinc-600
  "--w-rjv-arrow-color": "#a1a1aa", // zinc-400
  "--w-rjv-edit-color": "#a1a1aa",
  "--w-rjv-info-color": "#71717a", // zinc-500
  "--w-rjv-update-color": "#86efac", // green-300
  "--w-rjv-copied-color": "#86efac",
  "--w-rjv-copied-success-color": "#22c55e",
  "--w-rjv-curlybraces-color": "#a1a1aa",
  "--w-rjv-colon-color": "#a1a1aa",
  "--w-rjv-brackets-color": "#a1a1aa",
  "--w-rjv-ellipsis-color": "#71717a",
  "--w-rjv-type-string-color": "#86efac", // green-300
  "--w-rjv-type-int-color": "#93c5fd", // blue-300
  "--w-rjv-type-float-color": "#93c5fd",
  "--w-rjv-type-bigint-color": "#93c5fd",
  "--w-rjv-type-boolean-color": "#fcd34d", // amber-300
  "--w-rjv-type-date-color": "#f9a8d4", // pink-300
  "--w-rjv-type-url-color": "#7dd3fc", // sky-300
  "--w-rjv-type-null-color": "#f87171", // red-400
  "--w-rjv-type-nan-color": "#f87171",
  "--w-rjv-type-undefined-color": "#a1a1aa",
};

export { lightTheme };
